const removeTrailingSlashes = (
  value = ""
) => String(value).replace(/\/+$/, "");

export const TUTORIAL_API_ORIGIN =
  removeTrailingSlashes(
    process.env
      .REACT_APP_TUTORIAL_API_URL ||
      "https://api.monappliclub.com"
  );

export const TUTORIAL_CONFIG = {
  apiOrigin: TUTORIAL_API_ORIGIN,

  appKey:
    process.env
      .REACT_APP_TUTORIAL_APP_KEY ||
    "monappli-club",

  siteKey:
    process.env
      .REACT_APP_TUTORIAL_SITE_KEY ||
    "",

  locale:
    process.env
      .REACT_APP_TUTORIAL_LOCALE ||
    "fr-FR",
};